import { BudgetPageActions } from '../actions';
import { BudgetPage } from '../stores';
import Immutable from 'seamless-immutable';

const initialState = Immutable(BudgetPage);

export function budgetPage(store = initialState, action) {
	switch (action.type) {
		case BudgetPageActions.GetBudgetPageAction.Request: {
			return store.merge({
				isBudgetPageLoading: true
			});
		}
		case BudgetPageActions.GetBudgetPageAction.Success: {
			return store.merge({
				budgetPage: action.payload,
				isBudgetPageLoading: false
			});
		}
		case BudgetPageActions.GetBudgetPageAction.Failure: {
			return store.merge({
				isBudgetPageLoading: false
			});
		}
		default: {
			return store;
		}
	}
}
